import LegalLayout, { Section, LEGAL_CONTACT } from "@/components/LegalLayout";

export default function Refunds() {
  return (
    <LegalLayout
      eyebrow="Legal"
      title="RETURNS, REFUNDS & CANCELLATIONS."
      intro="Powders are food, so returns are handled with care and hygiene in mind. Short version: if something reaches you damaged, wrong or missing, we make it right."
    >
      <Section title="Cancellations">
        <p>Cancel free of charge any time before your order ships — call or WhatsApp {LEGAL_CONTACT.phone} or email {LEGAL_CONTACT.email} with your order ID. Once shipped, an order cannot be cancelled, but you may refuse delivery and we will refund per the rules below.</p>
      </Section>

      <Section title="Damaged, wrong or missing items">
        <p>Tell us within <strong>7 days of delivery</strong> at {LEGAL_CONTACT.email} or {LEGAL_CONTACT.phone}, with your order ID and a photo of the item/packaging. If the pouch arrived damaged, leaked, expired or you received the wrong product, we will send a free replacement — or a full refund if you prefer. No need to ship anything back unless we ask.</p>
      </Section>

      <Section title="Returns of opened food">
        <p>For hygiene and food-safety reasons, opened or partially used pouches cannot be returned unless the product is genuinely defective (for example, contamination on arrival) — in which case a photo is enough, and we replace or refund fully.</p>
      </Section>

      <Section title="Change-of-mind returns">
        <p>Unopened, sealed pouches can be returned within 7 days of delivery for a refund of the product price (shipping costs are non-refundable). Return shipping is borne by you unless the return is our mistake.</p>
      </Section>

      <Section title="Refund timelines">
        <p>Once we approve a refund:</p>
        <p>• Online payments (Razorpay): refunded to the original payment method in 5–7 business days, processed by the gateway.<br />
        • Cash on Delivery: refunded to your bank account or UPI ID (we will collect your preferred details once).<br />
        • Coupon or bundle savings are returned proportionately — you never lose out on a live promotion because of our refund.</p>
      </Section>

      <Section title="What is not covered">
        <p>Damage caused after delivery (poor storage, torn pouches on your shelf), products past the 7-day reporting window without a defect claim, and repeated change-of-mind returns we may reasonably limit.</p>
        <p>Nothing here limits your rights under the Consumer Protection Act, 2019 or FSSAI rules.</p>
      </Section>

      <Section title="Need help?">
        <p>Email {LEGAL_CONTACT.email} or WhatsApp {LEGAL_CONTACT.phone} with your order ID — a human replies, usually within a few hours.</p>
      </Section>
    </LegalLayout>
  );
}
